import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, wasExplicitLogout } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';
export function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return (_jsx("div", { className: "flex min-h-screen items-center justify-center", children: _jsx(Loader2, { className: "size-8 animate-spin text-primary" }) }));
    }
    if (!user) {
        return _jsx(Navigate, { to: "/login", replace: true, state: wasExplicitLogout() ? undefined : { from: location.pathname + location.search } });
    }
    // Mot de passe temporaire, puis double authentification imposée : aucun autre écran avant
    if (user.mustChangePassword && location.pathname !== '/change-password') {
        return _jsx(Navigate, { to: "/change-password", replace: true });
    }
    if (!user.mustChangePassword && user.twoFactorSetupRequired && location.pathname !== '/securite/2fa') {
        return _jsx(Navigate, { to: "/securite/2fa", replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
//# sourceMappingURL=ProtectedRoute.js.map